<template>
  <!-- <hm-content title=""> -->

  <div v-if="!flag" class="p10 content">
    <!-- https://imgcdn.hemiao100.com/ThemePictures/%E7%9B%AE%E6%A0%87%E5%88%B6%E5%AE%9A-%E5%BC%95%E5%AF%BC.png -->
    <div class="el-dialog-guide" @click="closeGuide" v-if="show"></div>
    <div class="mb10" style="background: #fff; padding: 20px">
      <div class="flex flex-between">
        <el-button type="primary" size="small" @click="add"
          >创建新目标</el-button
        >
        <div>
          <el-input
            clearable
            v-model.trim="searchCondition.planName"
            placeholder="请输入目标名称"
            size="small"
            style="width: 222px"
            class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
        </div>
      </div>
      <div class="mt10">
        <el-radio-group
          v-model="searchCondition.planState"
          size="small"
          @change="cashTypeTab"
        >
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="notStart">未开始</el-radio-button>
          <el-radio-button label="running">进行中</el-radio-button>
          <el-radio-button label="overdue">已结束</el-radio-button>
          <el-radio-button label="offline">已下线</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="img-guide" v-if="show">
      <el-image
        style="width:1400px"
        src="https://imgcdn.hemiao100.com/ThemePictures/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20201126193423.png"
      >
      </el-image>
      <img
        @click="closeGuide"
        class="img pointer"
        src="https://imgcdn.hemiao100.com/ThemePictures/%E7%9F%A5%E9%81%93%E4%BA%86%402x.png"
        alt=""
      />
    </div>

    <div
      v-for="(v, i) in list"
      :key="i"
      class="mb10  p10"
      :class="v.enabledState === 'no' ? 'offline' : 'okr'"
    >
      <div class="flex flex-between mb10">
        <div class="flex item-center">
          <div class="target-name">目标：{{ v.planName }}</div>
          <div class="target-value">{{v.toPrice }}</div>
          <div class="person-liable">总目标负责人：{{ v.realName }}</div>
        </div>
        <div class="flex item-center edit-box">
          <el-tooltip class="item" content="下线" placement="top">
            <div class="pointer edit" v-if="v.enabledState === 'yes'">
              <span
                class="hmicon icon-xiaxian2 orange"
                style="font-size: 18px"
                @click="offline(v)"
              ></span>
            </div>
          </el-tooltip>

          <el-divider
            v-if="v.enabledState === 'yes' && v.isCanDelete === 'yes'"
            direction="vertical"
          ></el-divider>
          <el-tooltip class="item" content="删除" placement="top">
            <div class="pointer edit" v-if="v.isCanDelete === 'yes'">
              <span
                class="hmicon icon-shanchu danger"
                style="font-size: 18px"
                @click="del(v)"
              ></span>
            </div>
          </el-tooltip>
        </div>
      </div>
      <div style="width: 600px" class="mt20">
        <el-steps :active="v.active" process-status="wait" align-center>
          <el-step
            icon="el-icon-edit"
            :title="o.title"
            v-for="(o, k) in stepList"
            :key="k"
          >
            <div slot="icon">
              <el-tooltip
                class="item"
                effect="dark"
                :content="
                  k + 1 < v.active
                    ? o.complete
                    : v.active === k + 1
                    ? o.doing
                    : o.disable
                "
                placement="top"
              >
                <div
                  class="circular flex flex-center item-center"
                  :class="{
                    'circular-active':
                      v.active <= stepList.length + 1 && v.active > k
                  }"
                >
                  <span
                    style="font-size:22px"
                    class="hmicon"
                    :class="v.active <= k + 1 ? o.icon : 'icon-duigou'"
                  >
                  </span>
                </div>
              </el-tooltip>
            </div>
          </el-step>
        </el-steps>
      </div>
      <div
        class="mt20 ml20 mb20 histogram"
        style="zindex: 99999"
        @click="getIndex(i)"
      >
        <el-image
          class="img"
          v-if="v.enabledState === 'no'"
          src="https://imgcdn.hemiao100.com/ThemePictures/xiaxian.png"
        >
        </el-image>
        <ve-histogram
          ref="histogram"
          v-show="v.splitInfoModels"
          :data="v.chartData"
          :extend="v.extend"
          :events="chartEvents"
        ></ve-histogram>
      </div>
    </div>
    <el-dialog
      :title="title"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1200px"
    >
      <div slot="title">
        {{ title }}
        <el-tooltip
          class="item"
          effect="dark"
          :content="type === 'no' ? '此目标暂未拆分，等待拆分确认中' : '已拆分'"
          placement="top"
        >
          (
          <span :class="type === 'no' ? 'danger' : 'success'">{{
            type === "no" ? "待拆分" : "已拆分"
          }}</span>
          )
        </el-tooltip>
      </div>
      <div v-if="dialogVisible">
        <div
          class="flex flex-center item-center okr-title bor-m mb20"
          style="color: #999"
        >
          <el-tooltip :content="details.planName" placement="top-start">
            <div class="flex-1 target-name text-overflow">
              目标：{{ details.planName }}
            </div>
          </el-tooltip>

          <div class="flex-2 text-center text-overflow" style="font-size: 17px">
            目标时间：{{ details.planStartDate
            }}{{ details.timeType === "year" ? "年" : "" }}至{{
              details.planEndDate
            }}{{ details.timeType === "year" ? "年" : "" }}
          </div>
          <div class="flex-1 target-value text-center">
            ￥{{ details.toPrice }}
          </div>
          <el-tooltip :content="details.realName" placement="top-start">
            <div class="flex-1 person-liable text-center text-overflow">
              总目标负责人：{{ details.realName }}
            </div>
          </el-tooltip>
        </div>

        <!-- <div class="flex flex-center item-center okr-title">
        <div class="flex-1 target-name">
          子目标：{{ detailInfoModel.planTargetName }}
        </div>
        <div class="flex-1 flex item-center">
          <el-progress
            style="width: 240px"
            :show-text="false"
            :stroke-width="12"
            :percentage="detailInfoModel.percentage"
          ></el-progress>
          <span class="ml10">{{ detailInfoModel.percentage }}%</span>
        </div>
        <div class="flex-1 flex flex-center target-value">
           <span :class="detailInfoModel.detailGoalTaskValue< detailInfoModel.detailConfirmTaskValue?'danger':'success'">{{ detailInfoModel.detailGoalTaskValue }}</span>/{{
            detailInfoModel.detailConfirmTaskValue
          }}
        </div>
        <div class="flex-1 target-value">
          负责人：{{ detailInfoModel.realName }}
        </div>
      </div> -->
        <div v-if="type === 'no'">
          <div class="mb20">
            <el-table
              :data="goodsList"
              style="width: 100%"
              border
              stripe
              size="small"
              :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
              :max-height="400"
              lazy
              row-key="id"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="planTargetName"
                label="目标"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="splitValue"
                label="目标销量"
              >
                <template slot-scope="scope"  header-align="center">
                  ￥{{ scope.row.toPrice }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="categoryLevel"
                label="目标状态"
              >
                <template slot-scope="scope">
                  <div
                    :class="
                      scope.row.splitState !== 'yes' ? 'danger' : 'success'
                    "
                  >
                    {{ scope.row.splitState !== "yes" ? "待拆分" : "已拆分" }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="realName"
                label="负责人"
              >
              </el-table-column>
            </el-table>
          </div>
          <div class="mb20">
            <el-table
              :data="shopList"
              style="width: 100%"
              stripe
              size="small"
              :max-height="400"
              lazy
              row-key="id"
              border
              :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="shopName"
                label="门店名称"
              >
                <template slot="header" slot-scope="scope">
                  门店名称({{ shopList.length }})
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="totalSplitValue"
                label="目标销量"
                width="350"
              >
                <template slot-scope="scope">
                  ￥{{ scope.row.toPrice }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="realName"
                label="负责人"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="mb20">
            <el-table
              :data="goodsList"
              style="width: 100%"
              border
              stripe
              size="small"
              :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
              :tree-props="{
                children: 'detailInfoModelList',
                hasChildren: 'isHaveChildren'
              }"
              :max-height="400"
              lazy
              row-key="id"
              :load="load"
            >
              <el-table-column
                header-align="left"
                align="left"
                prop="relGoodsName"
                label="目标"
                column-key="relGoodsName"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="percentage"
                label="目标销量百分比"
                column-key="percentage"
                width="350"
              >
                <template slot-scope="scope">
                  <div class="flex item-center">
                    <el-progress
                      :color="customColorMethod"
                      v-if="!isNaN(scope.row.percentage)"
                      style="width: 240px"
                      :show-text="false"
                      :stroke-width="12"
                      :percentage="scope.row.percentage"
                    ></el-progress>
                    <span class="ml10">{{ scope.row.percentage }}%</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="right"
                prop="detailGoalTaskValue"
                label="当前销量/目标销量"
              >
                <template slot-scope="scope">
                  <div>
                    <span
                      :class="
                        scope.row.detailGoalTaskValue <
                        scope.row.detailConfirmTaskValue
                          ? 'danger'
                          : 'success'
                      "
                      >￥{{ scope.row.detailGoalTaskValues }}</span
                    >
                    /￥{{ scope.row.detailConfirmTaskValues }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="realName"
                label="负责人"
                column-key="realName"
              >
              </el-table-column>
            </el-table>
          </div>
          <div class="mb20">
            <el-table
              :data="shopList"
              style="width: 100%"
              stripe
              size="small"
              :max-height="400"
              lazy
              row-key="id"
              border
              :load="loadShops"
              :tree-props="{
                hasChildren: 'isHaveChildren'
              }"
              :header-cell-style="{ background: '#f1f1f1', color: '#606266' }"
            >
              <el-table-column
                header-align="left"
                align="left"
                prop="shopName"
                label="门店名称"
                column-key="shopName"
                show-overflow-tooltip
              >
                <template slot="header" slot-scope="scope">
                  门店名称({{ shopList.length }})
                </template>
                <template slot-scope="scope">
                  <template>
                    {{ scope.row.shopName }}
                    <el-tag
                      size="mini"
                      effect="plain"
                      color="#FFEEF6"
                      v-if="!scope.row.isHaveChildren"
                      >待拆分</el-tag
                    >
                  </template>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="percentage"
                label="目标销量"
                width="400"
                column-key="percentage"
              >
                <template slot-scope="scope">
                  <div class="flex item-center">
                    <el-progress
                      :color="customColorMethod"
                      v-if="!isNaN(scope.row.percentage)"
                      style="width: 240px"
                      :show-text="false"
                      :stroke-width="12"
                      :percentage="scope.row.percentage"
                    ></el-progress>
                    <span class="ml10">{{ scope.row.percentage }}%</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="right"
                prop="detailGoalTaskValue"
                label="当前销量/目标销量"
                column-key="detailGoalTaskValue"
              >
                <template slot-scope="scope">
                  <div>
                    <span
                      :class="
                        scope.row.detailGoalTaskValue <
                        scope.row.detailConfirmTaskValue
                          ? 'danger'
                          : 'success'
                      "
                      >￥{{ scope.row.detailGoalTaskValues }}</span
                    >
                    /￥{{ scope.row.detailConfirmTaskValues }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="realName"
                label="负责人"
                column-key="realName"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="dialogVisible = false" type="primary" size="small"
          >关闭</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="下线提示"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleOffline"
    >
      <div class="flex flex-center">
        <span class="hmicon icon-tishi orange" style="font-size: 50px"></span>
      </div>
      <div class="flex flex-center orange mb20" style="font-size: 16px">
        提示
      </div>
      <div class="flex flex-center errtip">
        下线后将不可上线，是否确认要下线？
      </div>
      <div slot="footer" class="dialog-footer flex flex-center">
        <el-button
          @click="confirmOffline"
          size="small"
          style="background: #FF7F10;color:#fff"
          >确认下线</el-button
        >
        <el-button
          @click="dialogVisibleOffline = false"
          type="info"
          size="small"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
  <div v-else>
    <hm-content>
      <div class="flex flex-center item-center">
        <el-image
          style="width: 800px; height: 650px"
          :src="url"
          fit="fit"
        ></el-image>
      </div>
      <div class="mt10 flex flex-center">
        <!-- <el-button type="primary" size="small" @click="add">新增</el-button> -->
        <el-button type="primary" size="small" @click="add"
          >定制一个OKR</el-button
        >
      </div>
    </hm-content>
  </div>

  <!-- </hm-content> -->
</template>

<script>
import { toPrice } from "@/utils/utils";
import VeHistogram from "v-charts/lib/histogram.common";
// let echarts = require("echarts/lib/echarts");
// require("echarts/lib/chart/bar");
export default {
  components: { VeHistogram },
  data() {
    // this.chartSettings = {
    //   stack: { 用户: ["访问用户", "下单用户"] }
    // };
    var self = this;
    this.chartEvents = {
      click: function(e) {
        self.goSplitTarget(e);
      }
    };

    return {
      searchCondition: { planState: "", planName: "" },
      dialogVisibleOffline: false,
      show: true,
      title: "",
      dialogVisible: false,
      details: {},
      goodsList: [],
      stepList: [
        {
          title: "1.创建目标",
          icon: "icon-chuangjianmubiao",
          doing: "进入制定计划流程",
          complete: "目标计划已发布",
          disable: ""
        },
        {
          title: "2.目标拆分",
          icon: "icon-chaifenmubiao",
          doing: "进入目标拆分流程",
          complete: "目标已拆分完毕",
          disable: "当前尚未开启"
        },
        {
          title: "3.跟踪执行",
          icon: "icon-genzongzhihang",
          doing: "进入目标跟踪流程",
          complete: "计划已执行结束",
          disable: "当前尚未开启"
        },
        {
          title: "4.结果报告",
          icon: "icon-jieguobaogao1",
          doing: "报告已生成，请查收计划分析报告",
          complete: "报告已生成完毕",
          disable: "当前尚未开启"
        }
      ],
      active: 1,
      extend: {
        // 图标顶部的标题及按钮
        legend: {
          show: false,
          itemWidth: 15,
          itemHeight: 15
        },
        xAxis: {
          type: "category",
          show: true,
          // 坐标轴轴线
          axisLine: {
            show: true
          },
          splitLine: {
            show: false
          },
          // 坐标轴刻度
          axisTick: {
            show: true,
            inside: true,
            length: 10
          },
          // 坐标轴每项的文字
          axisLabel: {
            showMaxLabel: true,
            showMinLabel: true,
            color: "#000",
            rotate: 0, //刻度文字旋转，防止文字过多不显示
            margin: 8, //文字离x轴的距离
            boundaryGap: true,
            // backgroundColor:'#0f0',
            formatter: v => {
              // console.log('x--v',v)
              if (v.length > 3) {
                // return v.substring(0, 3) + "...";
              }
              return v;
            }
          }
        },
        yAxis: {
          show: false,
          offset: 0,
          // 坐标轴轴线
          axisLine: {
            show: false
          },
          // x轴对应的竖线
          splitLine: {
            show: false
          },
          // 坐标轴刻度
          axisTick: {
            show: false
          },
          boundaryGap: false,
          axisLabel: {
            // color: "#3a3a3a"
          }
        },
        // 柱形区域
        grid: {
          // show: true
          // backgroundColor: "#FFF6F3",
          // borderColor: "#FFF6F3"
          // containLabel:false,
        },

        // 每个柱子
        series(v) {
          // 设置柱子的样式
          v.forEach(i => {
            i.barWidth = 44;
            i.itemStyle = {
              opacity: 0.67,
              // borderColor: "rgba(31, 31, 31, 1)",
              borderWidth: 3.5,
              normal: {
                color: function(params) {
                  var colorList = [
                    "#000",
                    "#2f4554",
                    "#2f4554",
                    "#2f4554",
                    "#2f4554",
                    "#2f4554",
                    "#2f4554"
                  ];
                  if (params.seriesName === "访问用户") {
                    return colorList[0];
                  } else {
                    return colorList[1];
                  }
                }
              }
            };
            i.label = {
              color: "#666",
              show: true,
              position: "top",
              formatter: params => {
                console.warn(params);

                return params.value;
              }
              // backgroundColor:'yellow',
            };
          });
          return v;
        }
      },
      list: [
        // {
        //   extend: {
        //     // 图标顶部的标题及按钮
        //     legend: {
        //       show: false
        //     },
        //     xAxis: {
        //       type: "category",
        //       show: true,
        //       // 坐标轴轴线
        //       axisLine: {
        //         show: true
        //       },
        //       // 坐标轴刻度
        //       axisTick: {
        //         show: true,
        //         inside: true,
        //         length: 10
        //       },
        //       // 坐标轴每项的文字
        //       axisLabel: {
        //         showMaxLabel: true,
        //         showMinLabel: true,
        //         // color: "#000",
        //         rotate: 0, //刻度文字旋转，防止文字过多不显示
        //         margin: 8, //文字离x轴的距离
        //         boundaryGap: true,
        //         // backgroundColor:'#0f0',
        //         formatter: v => {
        //           // console.log('x--v',v)
        //           if (v.length > 3) {
        //             // return v.substring(0, 3) + "...";
        //           }
        //           return v;
        //         }
        //       }
        //     },
        //     yAxis: {
        //       show: false,
        //       offset: 0,
        //       // 坐标轴轴线
        //       axisLine: {
        //         show: false
        //       },
        //       // x轴对应的竖线
        //       splitLine: {
        //         show: false
        //       },
        //       // 坐标轴刻度
        //       axisTick: {
        //         show: false
        //       },
        //       boundaryGap: false,
        //       axisLabel: {
        //         color: "#3a3a3a"
        //       }
        //     },
        //     // 柱形区域
        //     grid: {
        //       left: 0
        //       // show: true
        //       // backgroundColor: "#FFF6F3",
        //       // borderColor: "#FFF6F3"
        //       // containLabel:false,
        //     },
        //     series: {
        //       barWidth: "30%",
        //       itemStyle: {
        //         opacity: 0.67,
        //         borderColor: "rgba(31, 31, 31, 1)",
        //         borderWidth: 1.5
        //       },
        //       barGap: "-100%",
        //       label: {
        //         color: "#666",
        //         show: true,
        //         position: "top",
        //         formatter: params => {
        //           console.log("params", params);
        //           if (params.seriesName === "访问用户") {
        //             return params.value;
        //           } else {
        //             return "";
        //           }
        //         },
        //         rich: {
        //           a: {
        //             color: "#fff",
        //             lineHeight: 20,
        //             height: 20,
        //             width: 44,
        //             backgroundColor: "#2FC348",
        //             align: "center",
        //             borderRadius: 4
        //           },
        //           b: {
        //             color: "#222",
        //             height: 20,
        //             align: "center"
        //           },
        //           x: {
        //             fontSize: 18,
        //             fontFamily: "Microsoft YaHei",
        //             borderColor: "#449933",
        //             borderRadius: 4
        //           }
        //         }
        //       }
        //     }
        //   }
        // }
      ],
      chartData: {
        columns: ["日期", "访问用户", "下单用户"],
        rows: [
          { 日期: "1/1", 访问用户: 1393, 下单用户: 0, 下单率: 0.32 },
          { 日期: "1/2", 访问用户: 3530, 下单用户: 0, 下单率: 0.26 },
          { 日期: "1/3", 访问用户: 2923, 下单用户: 2623, 下单率: 0.76 },
          { 日期: "1/4", 访问用户: 1723, 下单用户: 1423, 下单率: 0.49 },
          { 日期: "1/5", 访问用户: 3792, 下单用户: 3492, 下单率: 0.323 },
          { 日期: "1/6", 访问用户: 4593, 下单用户: 4293, 下单率: 0.78 }
        ]
      },
      url: "https://imgcdn.hemiao100.com/ThemePictures/home-okr.png",
      shopList: [],
      row: {},
      index: 0,
      type: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      flag: false
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList().then(res => {
      if (res.length === 0) {
        this.flag = true;
      }
    });
    // if(){

    // }
    // this.$nextTick(() => {
    //   this.$refs.histogram.echarts.on("hideTip", function(params) {
    //     console.log(params);
    //   });
    // });
    this.getGuiderShow();
  },
  methods: {
    cashTypeTab() {
      this.currentPage = 1;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async confirmOffline() {
      let params = JSON.parse(JSON.stringify(this.row));
      params.operationType = "offline";
      const { code } = await this.$store.dispatch(
        "editStoreOkrPlanBasicInfo",
        params
      );
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.dialogVisibleOffline = false;
        this.queryList();
      }
    },
    getGuiderShow() {
      const prams = localStorage.getItem("isShowGuider");

      if (prams) {
        this.show = false;
      }
    },
    setParamsCookie() {
      localStorage.setItem("isShowGuider", JSON.stringify({ show: this.show }));
    },
    offline(row) {
      this.row = row;
      this.dialogVisibleOffline = true;
    },
    del(row) {
      this.$confirm("是否确认删除？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        let params = JSON.parse(JSON.stringify(row));
        params.operationType = "del";
        this.$store.dispatch("editStoreOkrPlanBasicInfo", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    loadShops(tree, treeNode, resolve) {
      this.$store
        .dispatch("queryStoreOkrPlanEmployeeDetail", tree)
        .then(res => {
          if (res.code === "0" && res.result.length) {
            res.result.forEach(v => {
              v.percentage =
                Math.floor(
                  (v.detailGoalTaskValue / v.detailConfirmTaskValue) * 10000
                ) / 100;
              v.detailGoalTaskValues = toPrice(
                v.detailGoalTaskValue.toFixed(2)
              );
              v.detailConfirmTaskValues = toPrice(
                v.detailConfirmTaskValue.toFixed(2)
              );
            });
            resolve(res.result);
          } else {
            resolve([]);
          }
        });
    },
    load(tree, treeNode, resolve) {
      this.$store.dispatch("queryTargetSplitGoodsDetail", tree).then(res => {
        if (res.code === "0" && res.result.length) {
          res.result.forEach(v => {
            v.percentage =
              Math.floor(
                (v.detailGoalTaskValue / v.detailConfirmTaskValue) * 10000
              ) / 100;
            v.detailGoalTaskValues = toPrice(v.detailGoalTaskValue.toFixed(2));
            v.detailConfirmTaskValues = toPrice(
              v.detailConfirmTaskValue.toFixed(2)
            );
          });
          resolve(res.result);
        } else {
          resolve([]);
        }
      });
    },
    customColorMethod(percentage) {
      if (percentage >= 100) {
        return "#67c23a";
      }
    },
    async queryDetailsList() {
      if (this.type === "no") {
        const { code, result } = await this.$store.dispatch(
          "queryStoreOkrPlanForNoSplit",
          this.row
        );
        if (code === "0") {
          const {
            basicInfoModel,
            shopInfoModels,
            targetInfoModelList
          } = result;
          basicInfoModel.toPrice = toPrice(basicInfoModel.planValue.toFixed(2));
          targetInfoModelList.forEach(v => {
            v.toPrice = toPrice(v.splitValue.toFixed(2));
          });
          shopInfoModels.forEach(v => {
            v.toPrice = toPrice(v.splitValue.toFixed(2));
          });
          this.shopList = shopInfoModels;
          this.goodsList = targetInfoModelList;
          this.details = basicInfoModel;
          this.dialogVisible = true;
        }
      } else {
        const { code, result } = await this.$store.dispatch(
          "queryStoreOkrPlanForSplit",
          this.row
        );
        if (code === "0") {
          const {
            basicInfoModel,
            detailInfoModelList,
            shopDetailInfoModelList
          } = result;
          detailInfoModelList.forEach((v, i) => {
            v.relGoodsName = `子目标${i + 1}: ${v.relGoodsName}`;
            v.percentage =
              Math.floor(
                (v.detailGoalTaskValue / v.detailConfirmTaskValue) * 10000
              ) / 100;
            v.detailInfoModelList.forEach(o => {
              o.percentage =
                Math.floor(
                  (o.detailGoalTaskValue / o.detailConfirmTaskValue) * 10000
                ) / 100;
            });
            v.detailGoalTaskValues = toPrice(v.detailGoalTaskValue.toFixed(2));
            v.detailConfirmTaskValues = toPrice(
              v.detailConfirmTaskValue.toFixed(2)
            );
            if (v.detailInfoModelList.length) {
              v.detailInfoModelList.forEach(o => {
                o.detailGoalTaskValues = toPrice(
                  o.detailGoalTaskValue.toFixed(2)
                );
                o.detailConfirmTaskValues = toPrice(
                  o.detailConfirmTaskValue.toFixed(2)
                );
              });
            }
          });

          shopDetailInfoModelList.forEach(v => {
            // v.hasChildren = true;
            v.percentage =
              Math.floor(
                (v.detailGoalTaskValue / v.detailConfirmTaskValue) * 10000
              ) / 100;
            v.detailGoalTaskValues = toPrice(v.detailGoalTaskValue.toFixed(2));
            v.detailConfirmTaskValues = toPrice(
              v.detailConfirmTaskValue.toFixed(2)
            );
          });
          basicInfoModel.toPrice = toPrice(basicInfoModel.planValue.toFixed(2));

          this.shopList = shopDetailInfoModelList;
          this.goodsList = detailInfoModelList;
          this.details = basicInfoModel;
          this.dialogVisible = true;
          // const {
          //   basicInfoModel,
          //   shopInfoModels,
          //   targetInfoModelList
          // } = result;
          // this.shopList = shopInfoModels;
          // this.goodsList = targetInfoModelList;
          // this.details = basicInfoModel;
          // this.dialogVisible = true;
        }
      }
    },
    getIndex(i) {
      this.index = i;
    },
    goSplitTarget(e) {
      setTimeout(() => {
        // if (
        //   this.list[this.index].targetInfoModelList[e.dataIndex].splitState ===
        //   "yes"
        // ) {
        //   this.row = this.list[this.index].targetInfoModelList[e.dataIndex];
        //   this.title = this.row.timeValue + "详情";
        //   this.queryDetailsList();
        // }
        this.type = this.list[this.index].splitInfoModels[
          e.dataIndex
        ].splitState;
        this.row = this.list[this.index].splitInfoModels[e.dataIndex];
        this.title = this.row.timeValue + "详情";
        this.queryDetailsList();
      });
    },
    async queryList() {
      //       let params = {
      //   pageNo: this.currentPage,
      //   pageSize: this.pageSize
      // };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryStoreOkrPlanBasicList",
        searchCondition
      );
      if (code === "0") {
        result.forEach((v, i) => {
          if (v.planState === "createPlan") {
            v.active = 1;
          } else if (v.planState === "splitPlan") {
            v.active = 2;
          } else if (v.planState === "trackingExecution") {
            v.active = 3;
          } else if (v.planState === "resultsReports") {
            v.active = 4;
          }
          let totalDetailGoalTaskValue = 0;
          if (v.totalDetailGoalTaskValue && v.totalDetailGoalTaskValue != null) {
            totalDetailGoalTaskValue = v.totalDetailGoalTaskValue
          }
          v.toPrice = totalDetailGoalTaskValue + "/" + v.planValue;
          v.chartData = {
            columns: ["时间", "目标值"],
            rows: []
          };

          v.extend = {
            // 图标顶部的标题及按钮
            legend: {
              show: false
            },
            xAxis: {
              type: "category",
              show: true,
              // 坐标轴轴线
              axisLine: {
                show: true
              },
              // 坐标轴刻度
              axisTick: {
                show: true,
                inside: true,
                length: 10
              },
              // 坐标轴每项的文字
              axisLabel: {
                showMaxLabel: true,
                showMinLabel: true,
                color: "#000",
                rotate: 0, //刻度文字旋转，防止文字过多不显示
                margin: 8, //文字离x轴的距离
                boundaryGap: true,
                // backgroundColor:'#0f0',
                formatter: v => {
                  // console.log('x--v',v)
                  if (v.length > 3) {
                    // return v.substring(0, 3) + "...";
                  }
                  return v;
                }
              }
            },
            dataZoom: [
              {
                start: 0,
                type: "slider"
              }
            ],
            yAxis: {
              show: false,
              offset: 0,
              // 坐标轴轴线
              axisLine: {
                show: false
              },
              // x轴对应的竖线
              splitLine: {
                show: false
              },
              // 坐标轴刻度
              axisTick: {
                show: false
              },
              boundaryGap: false,
              axisLabel: {
                color: "#3a3a3a"
              }
            },
            // 柱形区域
            grid: {
              left: "0"
              // show: true
              // backgroundColor: "#FFF6F3",
              // borderColor: "#FFF6F3"
              // containLabel:false,
            },
            series: {
              barWidth: 50,
              // barMaxWidth: 100,
              // barMinWidth: "120px",
              barMinHeight: 100,
              itemStyle: {
                opacity: 0.67,

                borderWidth: 1.5,
                normal: {
                  opacity: 0.67,
                  borderColor: "rgba(31, 31, 31, 1)",
                  borderWidth: 1,
                  color: function(params) {
                    // console.log("params", params);
                    if (v.enabledState === "no") {
                      return "#999";
                    } else {
                      if (
                        result[i].splitInfoModels[params.dataIndex]
                          .splitState === "yes"
                      ) {
                        return "#2FC348";
                      } else {
                        return "#DDDDDD";
                      }
                    }

                    // var colorList = [
                    //   // "#FF0000",
                    //   "#2FC348",
                    //   "#DDDDDD",
                    //   "#DDDDDD",
                    //   "#DDDDDD",
                    //   "#DDDDDD"
                    // ];
                    // if (this.isSplit(params)) {
                    //   return colorList[0];
                    // } else {
                    //   return colorList[1];
                    // }
                  }
                }
              },

              label: {
                color: "#666",
                show: true,
                position: "top",
                formatter: params => {
                  if (v.enabledState === "no") {
                    if (
                      result[i].splitInfoModels[params.dataIndex].splitState ===
                      "yes"
                    ) {
                      let html = [
                        "{d|已拆分}",
                        `{b|￥${v.totalDetailGoalTaskValue}/${params.value}}`
                      ].join("\n");
                      return html;
                    } else {
                      let html = [
                        "{d|待拆分}",
                        `{b|￥${v.totalDetailGoalTaskValue}/${params.value}}`
                      ].join("\n");

                      return html;
                    }
                  } else {
                    if (
                      result[i].splitInfoModels[params.dataIndex].splitState ===
                      "yes"
                    ) {
                      let html = [
                        "{a|已拆分}",
                        `{b|￥${v.totalDetailGoalTaskValue}/${params.value}}`
                      ].join("\n");
                      return html;
                    } else {
                      let html = [
                        "{c|待拆分1}",
                        `{b|￥${v.totalDetailGoalTaskValue}/${params.value}}`
                      ].join("\n");

                      return html;
                    }
                  }
                },
                rich: {
                  a: {
                    color: "#fff",
                    lineHeight: 20,
                    height: 20,
                    width: 44,
                    backgroundColor: "#2FC348",
                    align: "center",
                    borderRadius: 4
                  },
                  b: {
                    color: "#222",
                    height: 20,
                    align: "center"
                  },
                  c: {
                    color: "#fff",
                    lineHeight: 20,
                    height: 20,
                    width: 44,
                    backgroundColor: "#FF0007",
                    align: "center",
                    borderRadius: 4
                  },
                  d: {
                    color: "#222",
                    lineHeight: 20,
                    height: 20,
                    width: 44,
                    backgroundColor: "#DDDDDD",
                    align: "center",
                    borderRadius: 4
                  },
                  x: {
                    fontSize: 18,
                    fontFamily: "Microsoft YaHei",
                    borderColor: "#449933",
                    borderRadius: 4
                  }
                }
              }
            }
          };

          if (v.splitInfoModels && v.splitInfoModels.length) {
            v.splitInfoModels.forEach(o => {
              o.目标值 = o.splitValue;
              o.时间 = o.timeValue;
              o.index = i;
              let totalDetailGoalTaskValue = 0;
              if (o.totalDetailGoalTaskValue) {
                totalDetailGoalTaskValue = o.totalDetailGoalTaskValue;
              }
              o.totalDetailGoalTaskValue = totalDetailGoalTaskValue;
              v.chartData.rows.push(o);
            });
          }
        });
        this.list = result;
        this.list.map((v, i) => {
          this.$nextTick(() => {
            this.$refs.histogram[i].echarts._api.getZr().on("click", params => {
              let pointInPixel = [params.offsetX, params.offsetY];
              if (
                this.$refs.histogram[i].echarts.containPixel(
                  "grid",
                  pointInPixel
                )
              ) {
                let xIndex = this.$refs.histogram[i].echarts.convertFromPixel(
                  { seriesIndex: 0 },
                  [params.offsetX, params.offsetY]
                )[0];
                let e = {
                  dataIndex: xIndex
                };
                this.goSplitTarget(e);
              }
            });
          });
        });
        return result;
      }
    },
    // drawLine() {
    //   // 基于准备好的dom，初始化echarts实例
    //   let myChart = echarts.init(document.getElementById("myChart"));
    //   // 绘制图表
    //   myChart.setOption({
    //     title: { text: "在Vue中使用echarts" },
    //     tooltip: {},
    //     xAxis: {
    //       // 坐标轴刻度
    //       axisTick: {
    //         show: true
    //       },
    //       axisLine: {
    //         show: true
    //       },
    //       data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"]
    //     },
    //     yAxis: {
    //       show: false,
    //       offset: 0,
    //       axisLine: {
    //         show: false
    //       },
    //       // 坐标轴刻度
    //       axisTick: {
    //         show: false
    //       },
    //       // x轴对应的竖线
    //       splitLine: {
    //         show: false
    //       }
    //     },
    //     series: [
    //       {
    //         name: "销量",
    //         type: "bar",
    //         data: [5, 20, 36, 10, 10, 20]
    //       }
    //     ],
    //     label: {
    //       position: "top",
    //       show: true
    //     },
    //     itemStyle: {
    //       //柱条的描边颜色。
    //       borderColor: "rgba(31, 31, 31, 1)",
    //       //柱条的描边宽度
    //       borderWidth: 3.5,
    //       //图形透明度
    //       opacity: 0.66
    //     },
    //     barWidth: 44
    //   });
    // },
    add() {
      // this.$router.push({
      //   name: "AddOkrWork"
      // });
      this.$router.push({
        name: "OkrWorkDevelop"
      });
    },
    closeGuide() {
      this.show = false;
      this.setParamsCookie();
    }
  }
};
</script>
<style lang="scss">
.offline {
  .el-step__title {
    color: #c0c4cc;
  }
}
</style>
<style lang="scss" scoped>
.el-dialog-guide {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  z-index: 2040;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  background: rgba(0, 0, 0, 0.7);
  // img {
  //   width: 100%;
  //   height: 100%;
  // }
}
.img-guide {
  position: relative;
  .img {
    position: absolute;
    width: 300px;
    height: 250px;
    top: 143px;
    left: 17px;
    z-index: 2041;
  }
}

.offline {
  background: #ffffff;
  border-left: 6px solid #999;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  .histogram {
    position: relative;
    .img {
      width: 130px;
      height: 130px;
      position: absolute;
      top: 20px;
      right: 20px;
    }
  }
  .edit-box {
    box-shadow: 0px 0px 26px 0px rgba(216, 216, 216, 0.9);
    .edit {
      margin: 5px;
    }
  }
  .bor-m {
    border-bottom: 1px solid #f4f4f4;
  }
  .okr-title {
    font-weight: 600;
    padding: 0 10px;
    height: 70px;
    font-size: 17px;
    div {
      margin-right: 80px;
    }
  }
  .circular {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid #dddddd;
    .hmicon {
      color: #999;
    }
  }
  .circular-active {
    background: #eee;
    .hmicon {
      color: #999;
    }
  }
}
.okr {
  background: #ffffff;
  border-left: 6px solid #e50065;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  .histogram {
    position: relative;
    .img {
      width: 130px;
      height: 130px;
      position: absolute;
      top: 20px;
      right: 20px;
    }
  }
  .edit-box {
    box-shadow: 0px 0px 26px 0px rgba(216, 216, 216, 0.9);
    .edit {
      margin: 5px;
    }
  }
  .bor-m {
    border-bottom: 1px solid #f4f4f4;
  }
  .okr-title {
    font-weight: 600;
    padding: 0 10px;
    height: 70px;
    font-size: 17px;
    div {
      margin-right: 80px;
    }
  }
  .circular {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid #dddddd;
    .hmicon {
      color: #999;
    }
  }
  .circular-active {
    background: #e50065;
    .hmicon {
      color: #fff;
    }
  }
}
.target-name {
  width: 400px;
  font-weight: 600;
  color: #222222;
  font-size: 22px;
}
.target-value {
  width: 200px;
  font-size: 20px;
  color: #222222;
}
.person-liable {
  font-size: 16px;
  font-weight: 400;
  color: #222222;
}
.circular {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #dddddd;
  .hmicon {
    color: #999;
  }
}
.circular-active {
  background: #e50065;
  .hmicon {
    color: #fff;
  }
}
// .circular-not-active {
//   background: #e50065;
// }
</style>
